import Button from './button.vue'
export default Button



// WEBPACK FOOTER //
// ./src/components/button/index.js